import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-icon_search",
  "use": "icon-icon_search-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-icon_search\"><defs><style></style></defs><path d=\"M988.365 952.115L770.458 734.208a425.984 425.984 0 1 0-36.25 36.25l217.907 217.907a25.6 25.6 0 1 0 36.25-36.25zM188.825 716.8a373.555 373.555 0 1 1 264.193 109.363A373.965 373.965 0 0 1 188.826 716.8z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol